export class Endpoints {
  static readonly BASE_FILES_PATH = `/apps/files`;
  static readonly BASE_LARGE_FILES_PATH = `/apps/files/large`;

  static readonly BASE_LARGE_APK_FILES_PATH = `/apps/files/large/apk/{{appId}}`;
  static readonly BASE_APK_FILES_PATH = `/apps/files/apk/{{appId}}`;
  static readonly BASE_ZIP_FILES_PATH = '/apps/files/zip';

  static readonly FILE_METADATA_PATH = '/apps/files/metadata/{{id}}';
  static readonly BASE_APP_DETAIL_FORM_PATH = `/apps/mandant/{{mandantId}}`;
  static readonly APP_BY_ID = '/apps/{{appId}}';
  static readonly APP_RELEASES_TOTAL_COUNT = '/apps/{{appId}}/releases/count';
  static readonly APPS_TOTAL_COUNT = 'apps/count';
  static readonly UPDATE_RELEASE = '/apps/releases/{{releaseId}}';
  static readonly GET_MANDANTS = '/mandants';
  static readonly FIRMWARE_BY_MANDANT_ID = '/firmwares/mandant/{{mandantId}}';
  static readonly FIRMWARE_TOTAL_COUNT =
    '/firmwares/mandant/{{mandantId}}/count';
  static readonly GET_BRANDS = 'brands/mandant/{{mandantId}}';
  static readonly DELETE_RELEASE_FILE =
    '/apps/files/{{id}}/releases/{{releaseId}}';
  static readonly GET_MODELS_BY_BRAND =
    '/models/mandant/{{mandantId}}/brand/{{brandId}}';
  static readonly GET_ECUS_BY_MODEL =
    '/ecus/mandant/{{mandantId}}/model/{{modelId}}';
  static readonly FIRMWARE_BY_ID =
    'firmwares/mandant/{{mandantId}}/firmware/{{firmwareId}}';
  static readonly CAMPAIGNS_BY_MANDANT_ID = '/campaigns/mandant/{{mandantId}}';
  static readonly GET_REPORTS_BY_CAMPAIGN =
    '/campaigns/mandant/{{mandantId}}/campaign/{{campaignId}}/report';
  static readonly GET_REPORTS_BY_CAMPAIGN_COUNT =
    '/campaigns/mandant/{{mandantId}}/campaign/{{campaignId}}/report/count';
  static readonly CAMPAIGN_BY_CAMPAIGN_ID =
    '/campaigns/mandant/{{mandantId}}/campaign/{{campaignId}}';
  static readonly CAMPAIGN_TOTAL_COUNT =
    '/campaigns/mandant/{{mandantId}}/count';

  static readonly GET_REVIEWS = '/reviews/{{mandantId}}';
  // TODO: REPLACE IF NECESSARY AFTER BACKEND IMPLEMENTATION
  static readonly GET_STATISTICS = '/statistics/{{mandantId}}';
  static readonly GET_STATISTICS_TOTAL_COUNT =
    '/statistics/{{mandantId}}/count';
  static readonly REVIEW_BY_ID = '/reviews/{{mandantId}}/{{id}}';
  static readonly REVIEW_TOTAL_COUNT = '/reviews/{{mandantId}}/count';
  static readonly GET_REVIEWS_STATS =
    '/reviews/{{mandantId}}/by-app/{{id}}/stats';
  static readonly GET_REVIEWS_FILTERS =
    '/reviews/{{mandantId}}/by-app/{{id}}/filters';
  static readonly ADD_REPLY = '/reply';
  static readonly WEB_GAMES = '/web-game';
  static readonly WEB_GAME_BY_ID = '/web-game/{{id}}';
  static readonly WEB_GAMES_TOTAL_COUNT = '/web-game/count';

  static readonly GET_CATEGORIES = '/categories';

  static readonly GET_APP_EXCEPTIONS = 'apps/exceptions';
}
